import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IBanner } from '@nx-ng/types';
import { BannerActions, GtmActions, RetryActions } from './actions';
import { ApplicationState } from './types';
import { selectBannerState } from './selectors/banner.selectors';
import { selectActionsToRetry } from './selectors/retry.selectors';
import { selectGtmIsEnabled } from './selectors/gtm.selectors';
import { selectGlobalLoading } from './selectors/loader.selectors';

@Injectable({
  providedIn: 'root',
})
export class CoreFacade {
  bannerState$ = this.store.select(selectBannerState);
  gtmEnabled$ = this.store.select(selectGtmIsEnabled);
  retryActions$ = this.store.select(selectActionsToRetry);
  globalLoading$ = this.store.select(selectGlobalLoading);

  constructor(private store: Store<ApplicationState>) {}

  dismissBanner(): void {
    this.store.dispatch(BannerActions.dismissBanner());
  }

  setBannerDetail(bannerDetails: IBanner) {
    this.store.dispatch(BannerActions.setBannerDetail({ bannerDetails }));
  }

  setGtmEnabled(isEnabled: boolean) {
    this.store.dispatch(GtmActions.setGtmEnabled({ isEnabled }));
  }

  retrySpecificActionTypes(types: string[]) {
    this.store.dispatch(RetryActions.retrySpecificActionTypes({ types }));
  }

  retryAllFailedActions() {
    this.store.dispatch(RetryActions.retryAllFailedActions());
  }

  clearRetryActions() {
    this.store.dispatch(RetryActions.clearRetryFailedActions());
  }
}
